import React from 'react'
import Stack from '@mui/material/Stack'
import { alpha, Portal } from '@mui/material'
import Box from '@mui/material/Box'
import Backdrop from '@mui/material/Backdrop'
import Typography from '@mui/material/Typography'
import AtlasAIButton from '../AtlasAIButton'
import Button from '@mui/material/Button'
import { useIsMobileDevice } from '../../hooks/useIsMobileDevice'

type LoadingBackdropProps = {
    title: string
    subtitle?: string
    loading: boolean
    cancelLabel?: string
    onCancel?: () => void
}

const LoadingBackdrop = ({ loading, onCancel, cancelLabel, title, subtitle }: LoadingBackdropProps) => {
    const isMobileDevice = useIsMobileDevice()

    return (
        <Portal>
            <Backdrop
                open={loading}
                sx={(theme) => ({
                    backgroundColor: alpha(theme.palette.figma.grayscale.contentWrapper, 0.85),
                    zIndex: theme.zIndex.modal + 100,
                })}
            >
                <Stack
                    direction="column"
                    gap={0.5}
                    height="100%"
                    width="100%"
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                >
                    <Box key={String(isMobileDevice)} pb={isMobileDevice ? 4 : 8}>
                        <AtlasAIButton size={isMobileDevice ? 125 : 200} isLoading />
                    </Box>
                    <Typography variant="22x700" color="figma.grayscale.textHier1">
                        {title}
                    </Typography>
                    {!!subtitle && (
                        <Typography variant="16x400" color="figma.grayscale.textHier2">
                            {subtitle}
                        </Typography>
                    )}
                    {!!onCancel && !!cancelLabel && (
                        <Box mt={1.5}>
                            <Button onClick={onCancel}>
                                <Typography variant="14x700" color="figma.grayscale.primary">
                                    {cancelLabel}
                                </Typography>
                            </Button>
                        </Box>
                    )}
                </Stack>
            </Backdrop>
        </Portal>
    )
}
export default LoadingBackdrop
